<mat-accordion>

    @for (accord of accordionSetup; track $index) {
    <mat-expansion-panel
        #accordPanel
        (afterCollapse)="markAsTouched(accord)"
    >
        <mat-expansion-panel-header
            [ngClass]="{'required-yellow': !isReadMode && !accordPanel.expanded && isAccordTouched(accord) && !isAccordValid(accord)}"
        >
            <mat-panel-title>{{accord.title}}<i>&nbsp;{{isReadMode || !accord.isRequired ? ' (optional)' : ' (Required)'}}</i></mat-panel-title>
            <mat-panel-description>{{accord.description}} 
            
                    <span class="required-msg"
                        [ngClass]="{
                            'yellow-color': accordPanel.expanded,
                            'invisible': isReadMode || !(isAccordTouched(accord) && !isAccordValid(accord))
                        }"
                    >
                        <span>Required</span>
                        <mat-icon>priority_high</mat-icon>
                    </span>

                @if (!isReadMode && accord.isRequired && isAccordValid(accord)) {
                    <mat-icon [@fadeInOut] class="valid-icon" style="margin-left: auto;">check_circle</mat-icon>
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        @if (accord.note && !isReadMode) {
        <lib-notice-card class="mt-2">{{accord.note}}</lib-notice-card>
        }

        <div class="upload-container mt-2">
            @if (!isReadMode) {
            <div class="upload-button">
                <!-- Visible upload button. -->
                <button mat-stroked-button type="button" (click)="hiddenUpload.click()"
                    [title]="accord.buttonTooltip">Upload<mat-icon matSuffix>upload</mat-icon></button>

                <!-- Hidden input. -->
                <input hidden type="file" 
                    #hiddenUpload
                    [multiple]="accord.multiple" 
                    [accept]="accord.accept"
                    (change)="onFileChange($event, accord); hiddenUpload.value = '';"
                >
            </div>
            }

            <!-- Each file will render here, either PDF or IMG. -->
            @for (file of fileMap[accord.fileMapKey]; track $index) {
            <div class="flex-nowrap" [ngClass]="{'upload-error': file.isFailed}">
                @if (file.isLoadingFromServer) {
                <div class="file-wrapper">
                    <mat-spinner diameter="50"></mat-spinner>
                </div>
                } @else {
                <div class="file-wrapper" (dblclick)="openFileInFullScreen(file)">
                    @switch (file.type) {
                    @case ("application/pdf") { <lib-pdf [srcUrl]="file.localUrl || file.serverUrl"
                        [filename]="file.filename"></lib-pdf> }
                    @case ("image/png") { <img [src]="file.serverUrl || file.safeLocalUrl" [alt]="accord.title"> }
                    @case ("image/jpeg") { <img [src]="file.serverUrl || file.safeLocalUrl" [alt]="accord.title"> }
                    @default {
                        <div style="overflow-wrap: break-word; word-break: break-word;">
                            <mat-icon>insert_drive_file</mat-icon>
                            <span>{{file.filename}}</span>
                        </div> 
                        }
                    }
                </div>
                }

                <div class="file-controls">
                    <!-- Delete button -->
                    @if (!isReadMode) {
                    <button mat-icon-button color="warn" (click)="removeFile($index, accord)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    }
                    
                    <!-- Open button -->
                    @if (!file.isLoadingFromServer) {
                    <button mat-icon-button color="primary" (click)="openFileInFullScreen(file)">
                        <mat-icon>open_in_new</mat-icon>
                    </button>
                    }

                    <!-- Re-upload button -->
                    @if (!isReadMode) {
                    <button *ngIf="!file.isUploadedToServer && !file.isUploading" mat-icon-button color="accent"
                        (click)="onUploadFile(file, accord)">
                        <mat-icon>upload</mat-icon>
                    </button>
                    }

                    <!-- Spinner while uploading. -->
                    <button mat-icon-button color="accent" *ngIf="file.isUploading">
                        <mat-spinner diameter="20"></mat-spinner>
                    </button>

                    <span *ngIf="file.isFailed" [@fadeInOut] class="upload-error">Failed to upload</span>
                </div>
            </div>
            }
        </div>

    </mat-expansion-panel>
    }

</mat-accordion>